<template>
  <div class="text-xs-center loader-wrapper">
    <!-- <v-progress-circular
      indeterminate
      color="primary"
      :size="50"
    ></v-progress-circular> -->
    <lottie :options="loaderOptions" :height="50" :width="50" v-on:animCreated="handleAnimation" />
  </div>
</template>

<script>
import Lottie from './Lottie.vue';
import * as loader from '@/assets/animations/loading.json';

export default {
  components: {
    lottie: Lottie
  },
  data() {
    return {
      loaderOptions: { animationData: loader.default },
      animationSpeed: 1
    };
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    }
  }
};
</script>

<style lang="scss" scoped>
.loader-wrapper div {
  border-radius: 10%;
}
</style>
